import { ChevronRight, Search } from 'lucide-react';
import Image from 'next/image';
import Link from 'next/link';
import { useRouter } from 'next/router';

export default function Sidebar({ allPosts = [] }) {
  const router = useRouter();

  const search = router.query.q || '';
  const category = router.query.category || '';
  const tag = router.query.tag || '';

  const categories = [...new Set(allPosts.map(p => p.category).filter(Boolean))];
  const tags = [...new Set(allPosts.flatMap(p => p.tags || []).filter(Boolean))];
  const recentPosts = allPosts.slice(0, 3);

  // 🔥 SEARCH LIVE UPDATE
  const handleSearchChange = (value) => {
    const query = {
      ...router.query,
    };

    if (value) query.q = value;
    else delete query.q;

    router.push(
      {
        pathname: '/blog',
        query,
      },
      undefined,
      { shallow: true }
    );
  };

  // 🔥 CATEGORY TOGGLE
  const handleCategory = (cat) => {
    const query = { ...router.query };

    if (query.category === cat) {
      delete query.category;
    } else {
      query.category = cat;
    }

    router.push(
      { pathname: '/blog', query },
      undefined,
      { shallow: true }
    );
  };

  // 🔥 TAG TOGGLE
  const handleTag = (t) => {
    const query = { ...router.query };

    if (query.tag === t) {
      delete query.tag;
    } else {
      query.tag = t;
    }

    router.push(
      { pathname: '/blog', query },
      undefined,
      { shallow: true }
    );
  };

  // 🔥 CLEAR ALL
  const clearAll = () => {
    router.push('/blog');
  };

  return (
    <div className="space-y-12">

      {/* SEARCH */}
      <div className="bg-background p-6">
        <div className="relative">
          <input
            type="text"
            placeholder="Search blog..."
            value={search}
            onChange={(e) => handleSearchChange(e.target.value)}
            className="w-full px-4 py-2 pr-10 text-black"
          />

          <button
            onClick={() => handleSearchChange(search)}
            className="absolute right-2 top-1/2 -translate-y-1/2"
          >
            <Search size={18} />
          </button>
        </div>

        {search && (
          <button
            onClick={() => handleSearchChange('')}
            className="text-sm mt-2 underline text-gray-600"
          >
            Clear search
          </button>
        )}
      </div>

      {/* RECENT POSTS */}
      <div className="bg-background p-6">
        <h3 className="text-2xl mb-4">Recent Posts</h3>

        <ul className="space-y-4">
          {recentPosts.map((post, i) => (
            <li key={i} className="flex gap-4">
              <div className="relative w-24 h-16">
                <Image
                  src={post.image}
                  alt={post.title}
                  fill
                  className="object-cover"
                />
              </div>

              <Link href={post.link}>
                <span className="hover:text-primary cursor-pointer">
                  {post.title}
                </span>
              </Link>
            </li>
          ))}
        </ul>
      </div>

      {/* CATEGORIES */}
      <div className="bg-background p-6">
        <h3 className="text-2xl mb-4">Categories</h3>

        <ul className="space-y-2">
          {categories.map((cat, i) => (
            <li key={i}>
              <button
                onClick={() => handleCategory(cat)}
                className={`flex items-center gap-2 ${
                  category === cat ? 'text-primary font-bold' : ''
                }`}
              >
                <ChevronRight size={16} />
                {cat}
              </button>
            </li>
          ))}

          {/* CLEAR BUTTON */}
          {category && (
            <li className="pt-3 mt-3">
              <button
                onClick={() => handleCategory(category)}
                className="text-sm underline text-gray-600 hover:text-primary"
              >
                Clear filter
              </button>
            </li>
          )}
        </ul>
      </div>

      {/* TAGS */}
      <div className="bg-background p-6">
        <h3 className="text-2xl mb-4">Tags</h3>

        <div className="flex flex-wrap gap-2">
          {tags.map((t, i) => (
            <button
              key={i}
              onClick={() => handleTag(t)}
              className={`px-3 py-2 ${
                tag === t
                  ? 'bg-primary text-white'
                  : 'bg-white hover:bg-primary hover:text-white'
              }`}
            >
              {t}
            </button>
          ))}
        </div>

        <button
          onClick={clearAll}
          className="text-sm underline mt-4"
        >
          Clear All Filters
        </button>
      </div>

    </div>
  );
}